import Vue from 'vue'
import _each from 'lodash/each' // Allows tree-shaking optimization

// Dynamic loading: https://element.eleme.io/#/fr-FR/component/quickstart#a-la-demande
import {
  // --Button,
  // --Card,
  // --Form,
  // --FormItem,
  // Form elements
  // Layout
  // Misc
  Aside,
  Autocomplete,
  Badge,
  ButtonGroup,
  Calendar,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  Container,
  DatePicker,
  Divider,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Footer,
  Header,
  Image,
  Input,
  Link,
  Loading,
  Main,
  Message, MessageBox, Dialog,
  Option,
  Pagination,
  Popover,
  Radio,
  RadioGroup,
  Row,
  Select,
  Switch,
  Table,
  TableColumn,
  Tag,
  TimeSelect,
  Tooltip, TimePicker, Upload
} from 'element-ui'

import BrowserContext from './components/BrowserContext.vue'
import Button from './components/Button.vue'
import Card from './components/Card.vue'
import CardContainer from './components/CardContainer.vue'
import Form from './components/forms/Form.vue'
import FormGroup from './components/forms/FormGroup.vue'
import FormItem from './components/forms/FormItem.vue'
import Icon from './components/Icon.vue'
import InputUrl from './components/forms/InputUrl.vue'
import ListFooter from './components/lists/ListFooter.vue'
import ListHeader from './components/lists/ListHeader.vue'
import ListSelection from './components/lists/ListSelection.vue'
import MessageCustom from './components/message'
import PageContainer from './components/PageContainer.vue'
import Panel from './components/Panel.vue'
import SearchContainer from './components/SearchContainer.vue'
import Slider from './components/Slider.vue'
import StatCircle from './components/statistics/StatCircle.vue'
import StatValue from './components/statistics/StatValue.vue'
import SwitchButton from './components/forms/SwitchButton.vue'

_each(
  [
    // Form elements
    // Layout
    // Misc
    Aside,
    Autocomplete,
    Badge,
    BrowserContext,
    Button,
    ButtonGroup,
    Calendar,
    Card,
    Card,
    CardContainer,
    Cascader,
    Checkbox,
    CheckboxGroup,
    Col,
    Collapse,
    CollapseItem,
    Container,
    DatePicker,
    Dialog,
    Divider,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Footer,
    Form,
    FormGroup,
    FormItem,
    Header,
    Icon,
    Image,
    Input,
    InputUrl,
    Link,
    ListFooter,
    ListHeader,
    ListSelection,
    Main,
    Message,
    Option,
    PageContainer,
    Pagination,
    Panel,
    Popover,
    Radio,
    RadioGroup,
    Row,
    SearchContainer,
    Select,
    Slider,
    StatCircle,
    StatValue,
    Switch,
    SwitchButton,
    Table,
    TableColumn,
    Tag,
    TimePicker,
    TimeSelect,
    Tooltip,
    Upload
  ],
  component => {
    Vue.component(component.name, component)
  }
)

// Utiliser la directive Loading standard d'Element UI
// Nous utilisons notre directive personnalisée dans main.js
Vue.use(Loading.directive)
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = MessageCustom

/**
 * Custom directive to add suffixes and prefixes to input text
 *
 * Examples:
 * - v-decorate="€" ---> append '€' to every value
 * - v-decorate.prefix="$" ---> prepend '$' to every value
 * - v-decorate.number="%" ---> force the value to be a valid float with '%' as a suffix
 */
Vue.directive('decorate', function (
  el,
  {
    value = '',
    oldValue = '',
    modifiers: { prefix = false, number = false, trim = false }
  }
) {
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    const els = el.getElementsByTagName('input')
    if (els.length !== 1) {
      throw new Error(
        'v-decorate directive requires 1 input, found ' + els.length
      )
    } else {
      el = els[0]
    }
  }

  const getElText = function () {
    let text = el.value || ''
    if (oldValue) {
      if (prefix) {
        if (el.value.substr(0, oldValue.length) === oldValue) {
          text = text.substr(oldValue.length)
        }
      } else {
        if (el.value.substr(-oldValue.length) === oldValue) {
          text = text.substr(0, text.length - oldValue.length)
        }
      }
    }
    if (number) {
      text = text.replace(/[^\-+\d.,\s]/gim, '')
      text = text.replace(/^[^\d+-]*([+-]?\d[\d\s]*([.,][\d\s]*)?).*$/, '$1')
    }
    if (trim || number) text = text.trim()
    return text
  }

  const getElValue = function (text) {
    return text ? (prefix ? `${value}${text}` : `${text}${value}`) : text
  }

  el.oninput = function (evt) {
    if (!evt.isTrusted) return // avoid infinite loop
    let position = el.selectionEnd
    const text = getElText()

    el.value = text
    const newEvt = document.createEvent('Event')
    newEvt.initEvent('input', true, true)
    el.dispatchEvent(newEvt, text)

    setTimeout(function () {
      el.value = getElValue(text)
      if (el.value !== text) {
        if (prefix) position += value.length
        else position = Math.min(el.value.length - value.length, position)
      }
      el.setSelectionRange(position, position)
    }, 0)
  }

  el.value = getElValue(getElText())
})
